import { ReactElement } from 'react';
import FooterLink from '../footerLink';
import FooterTitle from '../footerTitle';
import './styles.scss';

interface FooterListProps {
	data: {
		title: string;
		links: object[];
	};
	children?: ReactElement;
}

const FooterList: React.FC<FooterListProps> = ({ data, children }: FooterListProps) => (
	<div className="footerList">
		<FooterTitle title={data.title} />
		<ul className="footerList__list">
			{data.links.map((item: any, index: number) => (
				<FooterLink key={`footerList--${data.title}--${index}`} text={item.text} link={item.link} isExternal={item.isExternal} />
			))}
			{children}
		</ul>
	</div>
);

export default FooterList;
